import { ServerHttpResponseDecorator } from './exchange.ts';

export class HttpHeadResponseDecorator extends ServerHttpResponseDecorator {

}


